module.exports = __webpack_public_path__ + "icon-instagram.5a38d62a.svg";